import React, { useState } from 'react';
import {
  Input, Button, Icon, 
  Row, Col,
  Tabs, Upload
} from 'antd';
import jsonp from 'jsonp';
import { useImmer } from "use-immer";
import { TbFormItem, TbButton } from '../../components';
import CycleTag from './components/CycleTag';
import SquareTag from './components/SquareTag';
import CloseHoverContainer from './components/CloseHoverContainer/index';
import TSCEditorForm from './components/TSCEditorForm'
import ColorInput from './components/ColorInput'
import PreviewImageContainer, { Position } from './components/PreviewImageContainer/PreviewImageContainer'
import { toCanvas } from '../QrCode/utils';
import {
  defaultCyclePrometeTags,
  defaultSquarePrometeTags,
  CyclePrometeTag, 
  SquarePrometeTag,
  ThreeTagEntity
} from './prometeTags';
import useMouseDrag from '../../hooks/useMouseDrag'
import { getBase64 } from '../../components/TaobaoImgSelect/ImgSelect'
import './style.less';

const clsPrefix = 'cn-contact-picture'

const genURL = (itemNumId: string) => 'https://acs.m.taobao.com/h5/mtop.taobao.detail.getdetail/6.0/?data=' + encodeURIComponent(JSON.stringify({ itemNumId }))
const parseTaobaoUrl = (url: string) => {
  const match = /id=(.*)/.exec(url)
  if (match) {
    return {
      id: match[1]
    }
  }

  return false
}

function isString(x: string): x is string {
  return typeof x == 'string'
}

const ContactPicture: React.FC = () => {
  const [fetchUrl, setFetchUrl] = useState('')
  const [images, setImages] = useState<any[]>([])
  const [cyclePrometeTag, setCyclePrometeTag] = useImmer<CyclePrometeTag>(defaultCyclePrometeTags[0])
  const [squarePrometeTag, setSquarePrometeTag] = useImmer<SquarePrometeTag>(defaultSquarePrometeTags[0])
  const [showCycleTag, setShowCycleTag] = useState(false)
  const [showSquareTag, setShowSquareTag] = useState(false)
  const [dragImageIndex, setDragImageIndex] = useState(-1)
  const [contactImage, setContactImage] = useState({
    top: undefined,
    'bottom-left': undefined,
    'bottom-right': undefined
  })
  const [urlWrong, setUrlWrong] = useState(false)

  const tagRef = React.useRef(null);
  useMouseDrag(tagRef, {
    range: [0, 165, 308, 0]
  })
  const squareTagRef = React.useRef(null);
  useMouseDrag(squareTagRef, {
    range: [0, 0, 410, 0]
  })

  const handleSearch = () => {
    const goodsItem = parseTaobaoUrl(fetchUrl)

    if (goodsItem) {
      jsonp(genURL(goodsItem.id), function (err, data) {

        if (err) {
          setUrlWrong(true)
          return
        }

        setUrlWrong(false)
        setImages(data.data.item.images)
      })
    } else {
      setUrlWrong(true)
    }
  }

  function handleDragStart(e: any, index: number) {
    setDragImageIndex(index)
  }

  function handleDrop(part: Position) {
    setDragImageIndex(-1)
    setContactImage({
      ...contactImage,
      [part]: images[dragImageIndex]
    })
  }

  function handleDelete(i: number) {
    const imgs = [...images]
    imgs.splice(i, 1)
    setImages(imgs)
  }

  function handleSavingImg() {
    toCanvas('preview', 'pic-preview')
  }

  function handleRemovePreviewImage(part: Position) {
    setContactImage({
      ...contactImage,
      [part]: undefined
    })
  }

  function handleCycleClick(item: any) {
    setShowCycleTag(true)
    setCyclePrometeTag(draft => draft = item)
  }

  function handleSquareClick(item: any) {
    setShowSquareTag(true)
    setSquarePrometeTag(draft => draft = item)
  }

  function handleRemoveTag() {
    setShowCycleTag(false)
  }
  function handleRemoveSquareTag() {
    setShowSquareTag(false)
  }

  function handleSelectChange(info: any) {

    if (!info.file) return;

    if (info.file.status === 'removed') return;

    // Get this url from response in real world.
    if (info.file) {
      getBase64(info.file, (imageUrl: any) => {
        setImages([...images, imageUrl])
      });
    }
  }

  function handlePreviewImageChange(info: any, position: Position) {

    if (!info.file) return;
    if (info.file.status === 'removed') return;

    // Get this url from response in real world.
    if (info.file) {
      getBase64(info.file, (imageUrl: any) => {
        setContactImage({
          ...contactImage,
          [position]: imageUrl
        })
      });
    }
  }

  const cycleTagCloseStyle = {
    top: '8px',
    right: '5px'
  }
  const squareTagCloseStyle = {
    top: '0px',
    right: '0px'
  }

  return (
    <div className={clsPrefix}>
      <TbFormItem label='输入图片地址:'>
        <div className={`${clsPrefix}__imgcard-item`}>
          <Input
            className={`${clsPrefix}__imgcard-item--input`}
            value={fetchUrl} onChange={e => setFetchUrl(e.target.value)}
            placeholder='例: https://item.taobao.com/item.htm?id=583092538456'
          />
          <Button className={`${clsPrefix}__imgcard-item--btn`} type="danger" onClick={handleSearch} >搜索</Button>
        </div>
        <div className="tips">{urlWrong && ' *此链接无法被解析'}</div>
      </TbFormItem>
      <TbFormItem label="素材图片:">
        <div className={`${clsPrefix}__img`}>
          {images.map((img, index) => (
              <div draggable key={`img-${index}`} className={`${clsPrefix}__img-item`}>
                <CloseHoverContainer onClose={() => handleDelete(index)}>
                  <img className={`${clsPrefix}__img-item--src ${index === dragImageIndex ? 'dragging' : ''}`} src={img} onDragStart={e => handleDragStart(e, index)} />
                </CloseHoverContainer>
              </div>
          ))}
          <Upload
            accept=",jpeg,jpg"
            beforeUpload={() => false}
            showUploadList={false}
            onChange={(info) => handleSelectChange(info)}
          >
            <div className={`${clsPrefix}__img-item ${clsPrefix}__img-upload`}>
              <Icon className={`${clsPrefix}__img-upload--icon`} type="cloud-upload" />
              <div className={`${clsPrefix}__img-upload--btn`}>上传</div>
            </div>
          </Upload>
        </div>
        <div className="tips"> *拖拽至下方推广拼图预览 </div>
      </TbFormItem>
      <Row>
        <Col span={8}>
          <TbFormItem label="推广拼图预览:">
            <div
              id="preview"
              className={`${clsPrefix}__preview`}
            >
              <div
                className="tag"
                ref={tagRef}
              >
                {showCycleTag &&
                  <CloseHoverContainer closeStyle={cycleTagCloseStyle} onClose={handleRemoveTag}>
                    <CycleTag
                      backgroundColor={cyclePrometeTag.backgroundColor}
                      style={{ cursor: 'move' }}
                      items={cyclePrometeTag.items}
                    />
                  </CloseHoverContainer>
                }
              </div>
              <div
                className="tag"
                ref={squareTagRef}
              >
                {
                  showSquareTag && 
                  <CloseHoverContainer closeStyle={squareTagCloseStyle} onClose={handleRemoveSquareTag}>
                    <SquareTag
                      shape={squarePrometeTag.shape}
                      style={{ cursor: 'move' }}
                      items={squarePrometeTag.items}
                    />
                  </CloseHoverContainer>
                }
              </div>
              <div>
                <Row>
                  <PreviewImageContainer
                    onRemove={handleRemovePreviewImage}
                    onDrop={handleDrop}
                    position='top'
                    className='preview-top'
                    imgSrc={contactImage['top']}
                    onChange={handlePreviewImageChange}
                  />                
                </Row>
                <Row>
                  <Col span={12} className={`${clsPrefix}__preview-bottom`} >
                    <PreviewImageContainer
                      onRemove={handleRemovePreviewImage}
                      onDrop={handleDrop}
                      position='bottom-left'
                      className='preview-bottom-left'
                      imgSrc={contactImage['bottom-left']}
                      onChange={handlePreviewImageChange}
                    />      
                  </Col>
                  <Col className={`${clsPrefix}__preview-bottom`} span={12}>
                    <PreviewImageContainer
                      onRemove={handleRemovePreviewImage}
                      onDrop={handleDrop}
                      position='bottom-right'
                      className='preview-bottom-right'
                      imgSrc={contactImage['bottom-right']}
                      onChange={handlePreviewImageChange}
                    />
                  </Col>
                </Row>
              </div>
            </div>
          </TbFormItem>
          <TbButton
            content="生成推广图"
            theme='primary'
            onClick={handleSavingImg} 
          />
        </Col>
        <Col style={{marginTop: '40px'}} span={16}>
          <Tabs
            defaultActiveKey="1"
            type="card"
          >
            <Tabs.TabPane tab="圆形标签" key="1">
              <Row>
                {defaultCyclePrometeTags.map((item: CyclePrometeTag, index) => (
                  <Col span={5}>
                    <CycleTag
                      backgroundColor={item.backgroundColor}
                      onClick={() => handleCycleClick(item)}
                      items={item.items}
                    />
                  </Col>
                ))}
              </Row>
              <Row>
                <TSCEditorForm.Header />
                {[0, 1, 2, 3].map((item: any) => (
                  <TSCEditorForm
                    value={cyclePrometeTag.items[(item as keyof ThreeTagEntity)]}
                    onChange={newValue => {
                      setCyclePrometeTag(draft => {
                        draft.items[(item as keyof ThreeTagEntity)] = newValue
                      })
                    }}
                  />
                ))}
                <div>背景色:</div>
                <ColorInput
                  value={cyclePrometeTag.backgroundColor}
                  style={{ marginTop: '10px', padding: '4px' }} 
                  onChange={color => {
                    setCyclePrometeTag(draft => {
                      draft.backgroundColor = color
                    })
                  }}
                />
              </Row>
            </Tabs.TabPane>
            <Tabs.TabPane tab="长条标签" key="2">
              <Row>
                {defaultSquarePrometeTags.map((item: SquarePrometeTag) => (
                  <Col>
                    <SquareTag
                      shape={item.shape}
                      onClick={() => handleSquareClick(item)}
                      items={item.items}
                    />
                  </Col>
                ))}
              </Row>
              <Row>
                <TSCEditorForm.Header />
                {[0, 1, 2].map((item: any) => (
                  <TSCEditorForm
                    value={squarePrometeTag.items[(item as keyof ThreeTagEntity)]}
                    onChange={newValue => {
                      setSquarePrometeTag(draft => {
                        draft.items[(item as keyof ThreeTagEntity)] = newValue
                      })
                    }}
                  />
                ))}
              </Row>
            </Tabs.TabPane>
          </Tabs>
        </Col>
      </Row>
    </div>
  )
}

export default ContactPicture